import { render } from "./InvoiceBucketsPerformance.vue?vue&type=template&id=47ac8afa&scoped=true"
import script from "./InvoiceBucketsPerformance.vue?vue&type=script&lang=js"
export * from "./InvoiceBucketsPerformance.vue?vue&type=script&lang=js"

import "./InvoiceBucketsPerformance.vue?vue&type=style&index=0&id=47ac8afa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ac8afa"]])

export default __exports__